import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import useActiveTabFromParams from "@SearchResults/hooks/useActiveTabFromParams";
import RouteStatusType from "@Route/types/status/RouteStatus.type";
import {isEmpty} from "@Array/isEmpty";
import useFilterByPopularFilter from "./useFilterByPopularFilter";
import { useAppDispatch } from "@/hooks/dispatch/useAppDispatch";
import { setPopularFilter } from "@/pages/searchResults/reducers/filterSlice";
import { useEffect } from "react";
import useFlixbusViaTravelierConnectExperiment from "@SearchResults/features/experiments/hooks/useFlixbusViaTravelierConnectExperiment";
import ParamsType from "@SearchResults/types/params/Params.type";

type PopularFilterType = {
    displayMTicketFilter: boolean,
    displayInstantConfirmationFilter: boolean,
    displayWebDiscountFilter: boolean,
    displayDirectRoutesFilter: boolean,
}

export default function useDisplayPopularFilters(searchData: SearchResultsRtkQueryResponseType, params?: ParamsType): PopularFilterType {
    const activeTab = useActiveTabFromParams()
    const dispatch = useAppDispatch()
    const {
        filterByDirectRoutes,
        filterByInstantConfirmation,
        direct,
    } = useFilterByPopularFilter()

    // Get raw routes from API
    const rawRoutes = searchData.result.singleRoutes[activeTab]
    
    // Apply the same experiment filter logic that's used in usePrepareAndSortRoutes
    // Only apply experiment filter if params is available
    const {prepareRoutesForExperiment} = useFlixbusViaTravelierConnectExperiment(params as ParamsType)
    const filteredRoutes = params ? prepareRoutesForExperiment(rawRoutes) : rawRoutes

    const hasStatus = (statusKey: keyof RouteStatusType) => (
        rawRoutes.some((route) => route.status[statusKey])
    )

    const hasWebDiscounts: boolean = rawRoutes.some((route) => route.prices?.activeDiscount)
    const hasBusChangesOrIntermodalRoutes: boolean = !isEmpty(searchData.result.intermodalRoutes)
        || rawRoutes.some((route) => !isEmpty(route.travelInfo.busChange) || route.travelInfo.busChangeCount !== 0)
    const hasDirectRoutes: boolean = rawRoutes.some((route) => filterByDirectRoutes(route))

    // For instant confirmation, only show the filter if there are routes that would actually be visible
    // after the experiment filter removes company 4955 routes
    const hasInstantConfirmation = (route: any) => route.status?.isInstantConfirmation === true
    const hasInstantConfirmationRoutes: boolean = filteredRoutes.some((route) => hasInstantConfirmation(route))

    return {
        displayMTicketFilter: hasStatus('hasMTicket'),
        displayInstantConfirmationFilter: hasInstantConfirmationRoutes,
        displayWebDiscountFilter: hasWebDiscounts,
        displayDirectRoutesFilter: hasBusChangesOrIntermodalRoutes,
    }
}